import { useNavigate, useStore, usePathValidation } from '~hooks'
import {
  Title,
  Button,
  UserSelfieFirst,
  UserSelfieSecond,
  UserSelfieThird,
} from '~components'
import * as Styled from './styled'
import { useEffect } from 'react'
import { track } from '@amplitude/analytics-browser'

function SelfieDescription() {
  const navigate = useNavigate()
  const { update, register } = useStore()

  useEffect(() => {
    track('cadastro_rastreador', {
      tipo_veiculo: register.vehicleType,
      tipo_carroceria: register.vehicleBody,
    })
  }, [])

  useEffect(() => {
    update({ register: { progress: 70 } })
  }, [update])
  usePathValidation([
    'cpf',
    'plate',
    'register.cellphone',
    'register.fullName',
    'register.rntrc',
    'register.vehicleType',
    'register.vehicleBody',
    'register.vehicleTracking',
  ])

  function handleClick() {
    navigate('/cadastrar/selfie/tirar', { state: { previousPath: '/cadastrar/selfie'}})
  }

  return (
    <>
      <Title>Quase lá: hora da sua foto</Title>
      <Styled.Subtitle>
        Para sua segurança, precisamos garantir que ninguém está se passando por você.
      </Styled.Subtitle>
      <Styled.List>
        <Styled.Item>
          <UserSelfieFirst />
          <Styled.Text>
            Fique de frente para a câmera em um local bem iluminado
          </Styled.Text>
        </Styled.Item>
        <Styled.Item>
          <UserSelfieSecond />
          <Styled.Text>
            Evite o uso de óculos, chapéus, bonés ou qualquer outro acessório
          </Styled.Text>
        </Styled.Item>
        <Styled.Item>
          <UserSelfieThird />
          <Styled.Text>Centralize o seu rosto e não tire foto de outra foto</Styled.Text>
        </Styled.Item>
      </Styled.List>
      <Button width="100%" onClick={handleClick}>
        Tirar foto
      </Button>
    </>
  )
}

export default SelfieDescription
